import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChartCard } from '../ChartCard';
import { CountUp } from './CountUp';
import { tokens } from '../tokens';
import type { ChartData } from '../copilotTypes';

type StatData = Extract<ChartData, { chart: 'stat' }>;

/**
 * A single backend-computed figure. The big number is `data.value` (computed by the backend from the
 * queried rows — never model-authored); `summary` is the backend-templated takeaway sentence (the one
 * place a data value reaches the UI as prose). The model authored only the metric/range/stat op.
 */
export function StatCard({
  title,
  data,
  summary,
}: {
  title: string;
  data: StatData;
  summary?: string;
}) {
  return (
    <ChartCard title={title}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
          <Typography
            component="span"
            sx={{
              fontFamily: tokens.fontFamily,
              fontSize: 44,
              fontWeight: 700,
              lineHeight: 1.05,
              color: tokens.text.primary,
            }}
          >
            {/* The figure reads up to its true value and locks — integers stay grouped, non-integers
                keep 1 decimal (58.3). Backend-computed; the roll only animates the approach. */}
            <CountUp value={data.value} fractionDigits={Number.isInteger(data.value) ? 0 : 1} />
          </Typography>
          {data.unit ? (
            <Typography
              sx={{
                fontFamily: tokens.fontFamily,
                fontSize: 16,
                fontWeight: 500,
                color: tokens.text.secondary,
              }}
            >
              {data.unit}
            </Typography>
          ) : null}
        </Box>
        {summary ? (
          <Typography
            sx={{
              fontFamily: tokens.fontFamily,
              fontSize: 13,
              fontWeight: 500,
              color: tokens.text.secondary,
              lineHeight: 1.4,
            }}
          >
            {summary}
          </Typography>
        ) : null}
      </Box>
    </ChartCard>
  );
}
